"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollectionColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_field_cells_1 = require("../table-field/table-field-cells");
function useCollectionColumns() {
    const intl = (0, react_intl_1.useIntl)();
    const columns = (0, react_1.useMemo)(() => [
        {
            datakey: 'created',
            name: intl.formatMessage({
                id: 'EAS__COLLECTION__COLUMN__CREATED',
                defaultMessage: 'Vytvoření',
            }),
            width: 250,
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
        },
        {
            datakey: 'updated',
            name: intl.formatMessage({
                id: 'EAS__COLLECTION__COLUMN__UPDATED',
                defaultMessage: 'Poslední úprava',
            }),
            width: 250,
            CellComponent: table_field_cells_1.TableFieldCells.DateTimeCell,
        },
        {
            datakey: 'name',
            name: intl.formatMessage({
                id: 'EAS__COLLECTION__COLUMN__NAME',
                defaultMessage: 'Název',
            }),
            width: 250,
            CellComponent: table_field_cells_1.TableFieldCells.TextCell,
        },
        {
            datakey: 'createdBy.name',
            name: intl.formatMessage({
                id: 'EAS__COLLECTION__COLUMN__CREATED_BY',
                defaultMessage: 'Autor',
            }),
            width: 250,
            CellComponent: table_field_cells_1.TableFieldCells.TextCell,
        },
    ], 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [intl]);
    return columns;
}
exports.useCollectionColumns = useCollectionColumns;
//# sourceMappingURL=collection-columns.js.map